import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { Localization } from "@viamap/viamap2-common";
import { useContext, useEffect, useState } from "react";
import { addElement, deleteElements, FRPContext } from "./FRPState";
import { GlassInputControl, GlassInputGroup, GlassTextInputTransformer } from "src/components/GlassInput";
import { SelectColumn, SelectLayer } from "src/components/CommonInputs";
import { GlassButton } from "src/components/GlassButtons";
import { GlassInfo } from "src/components/MitGlassComponents";
import { ProtectedFeature } from "src/components/ProtectedFeature";
import { Feature } from "src/states/ApplicationStateFeatures";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { LayerInfo, LayerVariabilityType } from "src/common/managers/Types";
import { actionSetDataLayerVisibility, MapitStateContext } from "src/states/MapitState";
import { message } from "src/components/Message";
import { closeWindow, ManagedWindow, openWindow, WindowId } from "src/WindowManager/WindowState";
import { FRPFunc } from "./FRPFunc";

export function FRPImportDialog(props: { managedWindow: ManagedWindow, callbackOnClose: () => void }) {
   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);
   const { dispatch: windowDispatch } = useWindowContext();
   const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);

   const [availableLayers, setAvailableLayers] = useState<any>([]);
   const [selectedLayerId, setSelectedLayerId] = useState<number>();
   const [selectedIdColumn, setSelectedIdColumn] = useState<string>("");
   const [selectedGroupIdColumn, setSelectedGroupIdColumn] = useState<string>("");
   const [tagName, setTagName] = useState<string>();

   useEffect(() => {
      // Keep a list of available layers with Dgunr property
      let relevantLayers = Object.values(mapitState.layers)
         .filter((layerInfo: LayerInfo) => layerInfo.layerVariability !== LayerVariabilityType.FixedFeatureLayer);

      // .filter((layerInfo: LayerInfo) => {
      //    return (layerInfo.propertiesInGeoJson?.map((prop) => (prop.toLowerCase().includes("lbnr") || prop.toLowerCase().includes("id")))) && ([LayerType.GeoJSON_Polygon, LayerType.GeoJSON_Point].includes(layerInfo.type));
      // }
      // );
      let relevantLayerKeys = relevantLayers.map((lr) => { return lr.layerId }).sort();
      let availableLayerKeys = availableLayers.map((lr) => { return lr.layerId }).sort();
      // only update if there are new layers - not on any (e.g. data or styling change)
      if (!(relevantLayerKeys + "" === availableLayerKeys + "")) {
         setAvailableLayers(relevantLayers);
         if (relevantLayers && relevantLayers.length > 0) {
            let found = relevantLayers.find((lr) => lr.layerId === selectedLayerId);
            if (!found) {
               // default to first available layer
               setSelectedLayerId(relevantLayers[0].layerId);
            }
         } else {
            setSelectedLayerId(undefined);
         }
      }
   }, [mapitState.layers]);

   const FormControlElement = (props: { labelElement, controlElement }) => {
      return (
         <GlassTextInputTransformer label={props.labelElement} >
            {props.controlElement}
         </GlassTextInputTransformer>
      )
   }


   const renderLabel = (shortText: string, tooltip: string) => (
      <span title={tooltip} style={{ cursor: "pointer" }}>{shortText}</span>
   );

   function nameOnBlur(evt: any) {
      evt.preventDefault();
      setTagName(evt.target.value);
   }


   return (
      <AdvancedDragModal variant={"Small"} title={Localization.getText("FRPImportDialog:title")}
         window={props.managedWindow}
         PosDefault={{ left: "200px", top: "50%", transform: "translateY(-50%)", height: "400px", width: "500px" }}
         PosDefaultNS={{ width: "calc( 50% - 30px )", height: "calc(50% - 50px)", top: "50px", left: "15px" }}
      >
         <ADModalBody>
            <GlassInfo style={{ marginBottom: "20px" }}>
               <h5>{Localization.getText("Select a data layer to import")}</h5>
            </GlassInfo>
            <GlassInputGroup>

               <FormControlElement
                  labelElement={renderLabel(
                     Localization.getText("Layer"),
                     Localization.getText("Select a data layer to import")
                  )}
                  controlElement={(
                     <SelectLayer
                        availableLayers={availableLayers}
                        selectedLayerId={selectedLayerId!}
                        title={Localization.getText("MultiPointDataLayer")}
                        onSelect={(layerId: any) => {
                           setSelectedLayerId(layerId);
                        }} />
                  )}
               />
               <FormControlElement
                  labelElement={renderLabel(
                     Localization.getText("Element ID"),
                     Localization.getText("Select column for element id")
                  )}
                  controlElement={(
                     <SelectColumn
                        title={Localization.getText("Select column for element id")}
                        columns={mapitState.layers[selectedLayerId!]?.propertiesInGeoJson || []
                        }
                        defaultText={Localization.getText("id autogenereres")}
                        sKey={selectedIdColumn || ""}
                        onSelect={(columnId: any) => {
                           setSelectedIdColumn(columnId);
                        }} />
                  )}
               />
               <FormControlElement
                  labelElement={renderLabel(
                     Localization.getText("Group ID"),
                     Localization.getText("Select column for grouped by id")
                  )}
                  controlElement={(
                     <SelectColumn
                        title={Localization.getText("Select column for grouped by id")}
                        columns={mapitState.layers[selectedLayerId!]?.propertiesInGeoJson || []}
                        defaultText={Localization.getText("ingen")}
                        sKey={selectedGroupIdColumn || ""}
                        onSelect={(columnId: any) => {
                           setSelectedGroupIdColumn(columnId);
                        }} />
                  )}
               />
               <GlassTextInputTransformer
                  label={renderLabel(
                     Localization.getText("Tag"),
                     Localization.getText("Tag to add to imported elements (optional)")
                  )}
               >
                  <GlassInputControl>
                     <input
                        placeholder={Localization.getText("tagname (self-selected)")}
                        type='text'
                        value={tagName || ""}
                        onChange={(evt) => nameOnBlur(evt)}
                        autoComplete="off"
                     />
                  </GlassInputControl>
               </GlassTextInputTransformer>
            </GlassInputGroup>
         </ADModalBody>
         <ADModalFooter>
            {/* <ProtectedFeature feature={Feature.FRPProjectAdmin} contentsIfNoAccess={<></>} >
               <GlassButton
                  disabled={frpState.selectedProject?.protected}
                  onClick={() => {
                     runImport("Total Loader FRP data", true);
                  }}>Full Load DataForLayer (replace all)</GlassButton>
            </ProtectedFeature>
            {" "} */}
            <ProtectedFeature feature={Feature.FRPProjectWrite} contentsIfNoAccess={<>Unexpected: no access rights</>} >
               <GlassButton
                  onClick={() => {
                     runImport("Tilføjer FRP data", false);
                  }}>{Localization.getText("Add Data For Layer")}</GlassButton>
            </ProtectedFeature>
            {" "}
            <GlassButton
               onClick={() => {
                  windowDispatch(closeWindow(WindowId.FRPImport));
                  props.callbackOnClose();
               }}>{Localization.getText("Close")}</GlassButton>
         </ADModalFooter>
      </AdvancedDragModal>
   )

   function runImport(title: string, replaceAll: boolean) {
      if (selectedLayerId === undefined) {
         message.error(Localization.getText("Select a data layer"));
         return;
      }
      if (frpState.selectedProject === undefined) {
         message.error(Localization.getText("Select a project first"));
         return;
      }
      if (replaceAll && frpState.selectedProject?.protected) {
         message.error(Localization.getText("Project is protected. cannot replace all data"));
         return;
      }
      let li: LayerInfo = mapitState.layers[selectedLayerId];
      mapitStateDispatch(actionSetDataLayerVisibility(selectedLayerId, false));
      let geoJson = li.geoJson;
      let deleteIds: string[] = [];
      if (replaceAll) {
         deleteIds = Object.keys(frpState.elements)
      }


      const normalizeIdValue = (value: unknown, fallback: string = ""): string => {
         if (value === undefined || value === null) {
            return fallback;
         }
         const stringValue = String(value).trim();
         return stringValue.length > 0 ? stringValue : fallback;
      };

      let elements = FRPFunc.FRPElementsFromFeatureCollection(geoJson, (frpElement, feature) => ({
         ...frpElement,
         id: (() => {
            const rawValue = selectedIdColumn ? feature.properties[selectedIdColumn] : undefined;
            return normalizeIdValue(rawValue, frpElement.id);
         })(),
         refElementId: (() => {
            if (selectedGroupIdColumn) {
               const fromColumn = normalizeIdValue(feature.properties[selectedGroupIdColumn]);
               if (fromColumn) {
                  return fromColumn;
               }
            }

            // Check if all shown elements have the same refElementId. Then we insert it into the current view
            if (frpState.shownElementsIds.length > 0) {
               const firstRefElementId = normalizeIdValue(frpState.elements[frpState.shownElementsIds[0]]?.refElementId);
               const allHaveSameRefElementId = frpState.shownElementsIds.every(id =>
                  normalizeIdValue(frpState.elements[id]?.refElementId) === firstRefElementId
               );

               if (!allHaveSameRefElementId) {
                  const mismatchedElements = frpState.shownElementsIds.filter(id =>
                     normalizeIdValue(frpState.elements[id]?.refElementId) !== firstRefElementId
                  );
                  mismatchedElements.map(id => ({
                     id,
                     refElementId: frpState.elements[id]?.refElementId
                  }));
               }

               return allHaveSameRefElementId ? firstRefElementId : "";
            }
            return "";
         })(),
      }));


      const allElementIds = new Set([
         ...Object.keys(frpState.elements),
         ...elements.map(el => el.id)
      ]);

      elements = elements.map(el => {
         if (el.refElementId && !allElementIds.has(el.refElementId)) {
            return { ...el, refElementId: "" };
         }
         return el;
      });

      // Check for duplicate IDs
      const duplicateIds = elements.filter(el => frpState.elements[el.id]);
      if (duplicateIds.length > 0) {
         const duplicateIdList = duplicateIds.map(el => el.id).join(', ');

         windowDispatch(openWindow(WindowId.ConfirmationDialog, {
            header: "Duplicate Element IDs Detected",
            children: duplicateIds.length > 1
               ? Localization.getFormattedText("The following {amount} element IDs already exist and will be overwritten: {ids}. Do you want to proceed?", {
                  amount: duplicateIds.length,
                  ids: duplicateIdList
               })
               : Localization.getFormattedText("Element ID '{id}' already exists and will be overwritten. Do you want to proceed?", {
                  id: duplicateIdList
               }),
            onSubmit: () => {
               // Proceed with adding elements
               let nextID = elements.map((a) => a.id);
               for (let el of elements) {
                  frpDispatch(addElement(el.id, el));
               }
               if (replaceAll) {
                  frpDispatch(deleteElements(deleteIds.filter((a) => a && !nextID.includes(a))));
               }
               windowDispatch(closeWindow(WindowId.FRPImport));
            }
         }));
      } else {
         // No duplicates, proceed normally
         let nextID = elements.map((a) => a.id);
         for (let el of elements) {
            frpDispatch(addElement(el.id, el));
         }
         if (replaceAll) {
            frpDispatch(deleteElements(deleteIds.filter((a) => a && !nextID.includes(a))));
         }
         windowDispatch(closeWindow(WindowId.FRPImport));
      }
   }

}

